module.exports = __webpack_public_path__ + "img/tool2.9d85382d.png";